import { create } from 'zustand'

import {
  exportConsolidatedPreview,
  returnPreview,
  submitReturnPreview,
  getReturnPreviewDetails,
  getReturnPreview,
  saveDraftReturnPreview,
  deleteDraftReturnPreview,
  adjustPreview,
  getDeviationTypes
} from './provider'

import type { UsePreviewProps } from './types'

export const usePreview = create<UsePreviewProps>((set) => ({
  isDownloadPreviewLoading: false,
  setIsDownloadPreviewLoading: (value) => set({ isDownloadPreviewLoading: value }),

  isOpenConfirmExportPreview: false,
  setIsOpenConfirmExportPreview: (value) => set({ isOpenConfirmExportPreview: value }),

  isValidatePreviewLoading: false,
  setIsValidatePreviewLoading: (value) => set({ isValidatePreviewLoading: value }),

  isApprovePreviewLoading: false,
  setIsApprovePreviewLoading: (value) => set({ isApprovePreviewLoading: value }),

  isReturnPreviewLoading: false,
  setIsReturnPreviewLoading: (value) => set({ isReturnPreviewLoading: value }),

  isAdjustPreviewLoading: false,
  setIsAdjustPreviewLoading: (value) => set({ isAdjustPreviewLoading: value }),

  returnPreviewDetails: {},
  setReturnPreviewDetails: (data) => set({ returnPreviewDetails: data }),

  returnPreviewData: null,
  setReturnPreviewData: (data) => set({ returnPreviewData: data }),

  isFetchingReturnPreviewData: false,
  setIsFetchingReturnPreviewData: (value) => set({ isFetchingReturnPreviewData: value }),

  isSavingDraftReturnPreview: false,
  setIsSavingDraftReturnPreview: (value) => set({ isSavingDraftReturnPreview: value }),

  isDeletingDraftReturnPreview: false,
  setIsDeletingDraftReturnPreview: (value) => set({ isDeletingDraftReturnPreview: value }),

  deviationTypesBudget: [],
  setDeviationTypesBudget: (data) => set({ deviationTypesBudget: data }),

  deviationTypesS1: [],
  setDeviationTypesS1: (data) => set({ deviationTypesS1: data }),

  isDeviationTypesLoading: false,
  setIsDeviationTypesLoading: (value) => set({ isDeviationTypesLoading: value }),

  periodSelectedData: null,
  setPeriodSelectedData: (data) => set({ periodSelectedData: data }),

  persistedConsolidatedPreviewFilters: null,
  setPersistedConsolidatedPreviewFilters: (value) => set({ persistedConsolidatedPreviewFilters: value }),

  exportConsolidatedPreview,
  returnPreview,
  submitReturnPreview,
  getReturnPreviewDetails,
  getReturnPreview,
  saveDraftReturnPreview,
  deleteDraftReturnPreview,
  adjustPreview,
  getDeviationTypes
}))
